<template>
    <div
        :class="'section ' + section"
    >
        <h2
            class="title"
            @click="toggleIsExpanded()"
        >
            {{ sectionTitle }}
            <span
                v-if="isSectionExpanded"
                class="mdi mdi-chevron-down"
            />
            <span
                v-else
                class="mdi mdi-chevron-up"
            />
        </h2>
        <div
            v-if="isSectionExpanded"
            class="content"
        >
            <slot />
        </div>
    </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

export default defineComponent({
    name: 'Section',
    props: {
        section: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        toggleSection: {
            type: Function,
            required: true,
        },
        isExpanded: {
            type: Function,
            required: true,
        },
        isExpandable: {
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        const isSectionExpanded = computed(() => props.isExpanded(props.section));

        const sectionTitle = computed(() => (props.isExpandable ? props.title : `${props.title} (No Data)`));

        const toggleIsExpanded = () => {
            if (props.isExpandable) {
                props.toggleSection(props.section);
            }
        };

        return { isSectionExpanded, sectionTitle, toggleIsExpanded };
    }
});
</script>

<style lang="postcss" scoped>
.section {
    border-top: 1px solid #CCC;
}

.title {
    @apply flex items-baseline justify-between mt-2 mb-2 text-lg font-bold cursor-pointer;
}

.content {
    @apply my-8;
}
</style>
